export const toastCopyIt = {
    saved: "Salvato",
    savedForNow: "Salvato per il momento.",
    savedSuccessfully: "Salvato correttamente",
    errorSaving: "Errore durante il salvataggio",
    errorSavingTracker: "Errore durante il salvataggio del monitoraggio",
    updateFailed: "Aggiornamento non riuscito",
    errorUpdating: "Errore durante l'aggiornamento",
    errorCreating: "Errore durante la creazione",
    errorCreatingInput: "Errore durante la creazione del campo",
    errorCreatingDiaryLog: "Errore durante la creazione della voce del diario",
    errorCreatingEvent: "Errore durante la creazione dell'evento",
    errorUpdatingEvent: "Errore durante l'aggiornamento dell'evento",
    errorUpdatingProfile: "Errore durante l'aggiornamento del profilo, La preghiamo di riprovare",
    errorWhileUploading: "Errore durante l'invio",
    refreshAndRetry: "Errore, aggiorni la pagina e riprovi",
    noDataReturned: "Nessun dato restituito",
    settingsSaved: "Impostazioni salvate",
    copiedToClipboard: "Copiato negli appunti",
    linkCopiedToClipboard: "Link copiato negli appunti",
    pleaseSelectFile: "Selezioni un file",
    pasteImageFromClipboard: "Incolli un'immagine dagli appunti (Ctrl+V o Cmd+V)",
    loggedOutSuccess: "Disconnessione riuscita",
    loggingIn: "Accesso in corso",
    errorLoggingIn: "Errore di accesso",
    loginSuccessful: "Accesso riuscito",
    signUpSuccessful: "Registrazione riuscita",
    transferRequested: "Trasferimento richiesto - controlli la Sua e-mail per assicurarsi che sia andato a buon fine.",
    organisationAdded: "Organizzazione aggiunta",
    organisationAlreadyAdded: "Organizzazione già aggiunta",
    deletionRequestSent: "Richiesta di eliminazione inviata",
    userAuthenticated: "Utente autenticato",
    codeIncorrect: "Codice non corretto",
    codeCorrect: "Codice corretto",
    errorSigningIn: "Errore di accesso",
    otpFailedToSend: "Invio della password monouso non riuscito",
    passwordUpdatedSuccess: "Password aggiornata correttamente.",
    emailOrPasswordIncorrect: "E-mail o password non corretti",
    phoneNumberConfirmed: "Numero di telefono confermato",
    errorConfirmingPhoneNumber: "Errore durante la conferma del numero di telefono",
    profileUpdatedSuccess: "Profilo aggiornato correttamente",
    professionalDetailsSaved: "Informazioni professionali salvate.",
    failedUpdateProfessionalDetails: "Aggiornamento delle informazioni professionali non riuscito",
    templateCreatedSuccess: "Modello creato correttamente.",
    templatesCreatedSuccess: (count) =>
        count === 1 ? "Modello creato correttamente." : `${count} modelli creati correttamente.`,
    failedCreateTemplate: "Creazione del modello non riuscita",
    templateUpdatedSuccess: "Modello aggiornato correttamente",
    failedUpdateTemplate: "Aggiornamento del modello non riuscito",
    templateDeletedSuccess: "Modello eliminato correttamente",
    failedDeleteTemplate: "Eliminazione del modello non riuscita",
    templateDuplicatedSuccess: "Modello duplicato correttamente",
    failedDuplicateTemplate: "Duplicazione del modello non riuscita",
    templateSharedSuccess: "Modello condiviso correttamente",
    errorSharingTemplate: (message) => `Errore durante la condivisione del modello: ${message}`,
    analyticsViewSharedSuccess: "Vista condivisa correttamente",
    errorSharingAnalyticsView: (message) => `Errore durante la condivisione della vista: ${message}`,
    analyticsViewUnsharedSuccess: "Vista condivisa rimossa",
    errorUnsharingAnalyticsView: (message) => `Errore durante la rimozione della vista condivisa: ${message}`,
    trackerSaved: "Monitoraggio salvato",
    entryUpdatedSuccess: "Inserimento aggiornato correttamente",
    entrySaved: "Inserimento salvato",
    entryDeleted: "Inserimento eliminato",
    entryTimingUpdated: "Scadenza dell'inserimento aggiornata",
    scheduleUpdated: "Calendario aggiornato",
    entryRemovedFromSchedule: "Inserimento rimosso dal calendario",
    entryAssignedToScheduleStep: "Inserimento assegnato a un passaggio del calendario",
    stepAlreadyOccupied: "Questo passaggio ha già un inserimento.",
    diaryUpdatedSuccess: "Diario aggiornato correttamente",
    diaryInputsAddedSuccess: "Campi del diario aggiunti correttamente",
    diaryDiscardedSuccess: "Diario abbandonato correttamente",
    diaryReinstatedSuccess: "Diario riattivato correttamente",
    diaryDischargedSuccess: "Diario chiuso correttamente",
    diaryEnded: "Diario chiuso",
    labelCreated: "Etichetta creata",
    labelUpdated: "Etichetta aggiornata",
    labelDeleted: "Etichetta eliminata",
    labelsUpdated: "Etichette aggiornate",
    tableSettingsSaved: "Impostazioni della tabella salvate",
    detailsSaved: "Le Sue informazioni sono state salvate.",
    hospitalNumberRequired: "Il numero di cartella ospedaliera è obbligatorio",
    couldNotSaveHospitalNumber: "Impossibile salvare il numero di cartella ospedaliera",
    sharedAttributesUpdated: "Attributi condivisi aggiornati",
    errorUpdatingSharedAttributes: "Errore durante l'aggiornamento degli attributi condivisi",
    sharedAttributesCreated: "Attributi condivisi creati",
    errorCreatingSharedAttributes: "Errore durante la creazione degli attributi condivisi",
    diaryAccessSaved: "Accesso al diario salvato",
    failedSaveDiaryAccess: "Salvataggio dell'accesso al diario non riuscito",
    joinedDateGroupSuccess: "Gruppo di date unito correttamente",
    failedJoinDateGroup: (message) => `Unione al gruppo di date non riuscita: ${message}`,
    questionnaireStopped: "Questionario interrotto",
    errorStoppingQuestionnaire: "Errore durante l'interruzione del questionario",
    consentAddedToDiary: "Consenso aggiunto al diario",
    errorAddingConsentToDiary: "Impossibile aggiungere il consenso",
    eventSaved: "Evento salvato",
    eventUpdated: "Evento aggiornato",
    eventDeletedSuccess: "Evento eliminato correttamente",
    eventTrackerLinked: "Evento e monitoraggio collegati",
    errorLinkingEventTracker: (message) => `Errore durante il collegamento dell'evento e del monitoraggio. ${message}`,
    surgerySaved: "Operazione salvata",
    errorCreatingSurgery: "Errore durante la creazione della nuova operazione",
    surgeryOptionUpdated: "Opzione di operazione aggiornata",
    errorUpdatingSurgeryOption: "Errore durante l'aggiornamento dell'opzione di operazione",
    newSurgeryOptionSaved: "Nuova opzione di operazione salvata",
    consultationSaved: "Consulto salvato",
    errorCreatingConsultation: "Errore durante la creazione del nuovo consulto",
    errorUpdatingConsultation: "Errore durante l'aggiornamento del consulto",
    imagingRequestSaved: "Richiesta di diagnostica per immagini salvata",
    errorCreatingImagingRequest: "Errore durante la creazione della richiesta di diagnostica per immagini",
    injectionDetailsUpdated: "Informazioni sull'iniezione aggiornate",
    errorUpdatingInjectionDetails: "Errore durante l'aggiornamento delle informazioni sull'iniezione",
    injectionDiaryDefaultSaved: "Valore predefinito del diario di iniezione salvato",
    errorSavingInjectionDiaryDefault: "Errore durante il salvataggio del valore predefinito del diario di iniezione",
    diaryInjectionAdded: "Iniezione aggiunta al diario",
    errorCreatingDiaryInjection: "Errore durante la creazione dell'iniezione del diario",
    injectionContentUpdated: "Contenuto dell'iniezione aggiornato",
    failedUpdateInjectionContent: "Aggiornamento del contenuto dell'iniezione non riuscito",
    injectionContentDeleted: "Contenuto dell'iniezione eliminato",
    failedDeleteInjectionContent: "Eliminazione del contenuto dell'iniezione non riuscita",
    approvedStatusUpdated: "Stato di approvazione aggiornato",
    failedUpdateApprovedStatus: "Aggiornamento dello stato di approvazione non riuscito",
    publishedStatusUpdated: "Stato di pubblicazione aggiornato",
    failedUpdatePublishedStatus: "Aggiornamento dello stato di pubblicazione non riuscito",
    injectionLocationUpdated: "Sede di iniezione aggiornata",
    failedUpdateInjectionLocation: "Aggiornamento della sede di iniezione non riuscito",
    newInjectionLocationCreated: "Nuova sede di iniezione creata",
    failedCreateInjectionLocation: "Creazione della sede di iniezione non riuscita",
    newInjectionContentsCreated: "Nuovi contenuti di iniezione creati",
    failedCreateInjectionContents: "Creazione dei contenuti di iniezione non riuscita",
    failedSaveInjectionDetails: "Salvataggio delle informazioni sull'iniezione non riuscito",
    diaryShockwaveAdded: "Onde d'urto aggiunte al diario",
    errorCreatingDiaryShockwave: "Errore durante la creazione delle onde d'urto del diario",
    diaryShockwaveSaved: "Onde d'urto del diario salvate",
    shockwaveDetailsUpdated: "Informazioni sulle onde d'urto aggiornate",
    errorUpdatingShockwaveDetails: "Errore durante l'aggiornamento delle informazioni sulle onde d'urto",
    shockwaveDiaryDefaultSaved: "Valore predefinito del diario di onde d'urto salvato",
    errorSavingShockwaveDiaryDefault: "Errore durante il salvataggio del valore predefinito del diario di onde d'urto",
    shockwaveDetailsRemoved: "Informazioni sulle onde d'urto eliminate",
    failedSaveShockwaveDetails: "Salvataggio delle informazioni sulle onde d'urto non riuscito",
    scheduleUpdatedSuccess: "Calendario aggiornato correttamente",
    failedUpdateSchedule: "Aggiornamento del calendario non riuscito",
    scheduleDraftCreated: "Bozza di calendario creata",
    failedCreateScheduleFromDraft: "Creazione del calendario dalla bozza non riuscita",
    failedUpdatePublishStatus: "Aggiornamento dello stato di pubblicazione non riuscito",
    formUpdated: "Modulo aggiornato",
    failedUpdateForm: "Aggiornamento del modulo non riuscito",
    formDraftCreated: "Bozza di modulo creata",
    failedCreateFormFromDraft: "Creazione del modulo dalla bozza non riuscita",
    pageSaved: "Pagina salvata",
    failedSavePage: "Salvataggio della pagina non riuscito",
    pageDeleted: "Pagina eliminata",
    failedDeletePage: "Eliminazione della pagina non riuscita",
    questionSaved: "Domanda salvata",
    failedSaveQuestion: "Salvataggio della domanda non riuscito",
    questionDeleted: "Domanda eliminata",
    failedDeleteQuestion: "Eliminazione della domanda non riuscita",
    patientAddedSuccess: "Paziente aggiunto correttamente.",
    emailWordsUpdatedSuccess: "Testi delle e-mail aggiornati correttamente",
    failedUpdateEmailWords: "Aggiornamento dei testi delle e-mail non riuscito",
    emailSentSuccess: "E-mail inviata correttamente",
    diaryAlreadyRead: "Diario già letto",
    noLastReadAction: "Nessuna ultima azione di lettura trovata",
    actionComplete: (actionName) => `${actionName} completato`,
    footLogCreatedSuccess: "Diario del piede creato correttamente",
    imageUploadedSuccess: "Immagine inviata correttamente",
    imageLabelCreatedSuccess: "Etichetta dell'immagine creata correttamente",
    qipPermissionsUpdated: "Autorizzazioni QIP aggiornate correttamente",
    qipPermissionsUpdateFailed: "Aggiornamento delle autorizzazioni QIP non riuscito",
    riskAssessmentUpdateFailed: "Aggiornamento della valutazione del rischio non riuscito",
    footCommentSubmitted: (comment) => `Ha inviato il seguente commento:\n${comment}`,
    qrCodeNotReady: "Codice QR non ancora pronto",
    qrCodeCopiedToClipboard: "Codice QR copiato negli appunti",
    couldNotCopyQrImage:
        "Impossibile copiare l'immagine del codice QR. Provi invece con un'acquisizione dello schermo.",
    inviteSent: "Invito inviato",
    organisationRoleAddedSuccess: "Ruolo di organizzazione aggiunto correttamente",
    errorAddingOrganisationRole: (message) => `Errore durante l'aggiunta del ruolo di organizzazione: ${message}`,
    organisationRoleUpdatedSuccess: "Ruolo di organizzazione aggiornato correttamente",
    errorUpdatingOrganisationRole: (message) =>
        `Errore durante l'aggiornamento del ruolo di organizzazione: ${message}`,
    organisationRoleDeletedSuccess: "Ruolo di organizzazione eliminato correttamente",
    errorDeletingOrganisationRole: (message) => `Errore durante l'eliminazione del ruolo di organizzazione: ${message}`,
    secretaryAddedToOrganisation: "Assegnazione di segretario aggiunta",
    errorAddingSecretaryToOrganisation: (message) =>
        `Errore durante l'aggiunta dell'assegnazione di segretario: ${message}`,
    defaultSecretarySet: "Persona di contatto predefinita aggiornata",
    errorSettingDefaultSecretary: (message) =>
        `Errore durante l'impostazione della persona di contatto predefinita: ${message}`,
    defaultSecretaryCleared: "Persona di contatto predefinita rimossa",
    errorClearingDefaultSecretary: (message) =>
        `Errore durante la rimozione della persona di contatto predefinita: ${message}`,
    secretaryRemovedFromOrganisation: "Assegnazione di segretario rimossa",
    errorRemovingSecretaryFromOrganisation: (message) =>
        `Errore durante la rimozione dell'assegnazione di segretario: ${message}`,
    newOrganisationSaved: "Nuova organizzazione salvata",
    organizationCreatedSuccess: "Organizzazione creata correttamente.",
    audiencesUpdatedSuccess: "Pubblici aggiornati correttamente",
    errorUpdatingAudiences: "Errore durante l'aggiornamento dei pubblici",
    labelAccessUpdated: "Accesso per etichetta aggiornato",
    accessUpdated: "Accesso aggiornato",
    photoUpdatedSuccess: "Foto aggiornata correttamente",
    failedUpdatePhoto: "Aggiornamento della foto non riuscito",
    photoDeletedSuccess: "Foto eliminata correttamente",
    failedDeletePhoto: "Eliminazione della foto non riuscita",
    logoUpdatedSuccess: "Logo aggiornato correttamente",
    failedUpdateLogo: "Aggiornamento del logo non riuscito",
    logoDeletedSuccess: "Logo eliminato correttamente",
    failedDeleteLogo: "Eliminazione del logo non riuscita",
    smsDisabledInKnock: "SMS disattivati in Knock",
    failedUpdateKnockPreferences: "Aggiornamento delle preferenze Knock non riuscito",
    magicLinkGenerated: "Link magico generato",
    errorImpersonatingUser: "Errore durante l'impersonificazione dell'utente",
    fieldUpdatedSuccess: (field) => `${field} è stato aggiornato correttamente.`,
    lockUnlockReasonRequired: (action) =>
        `Il motivo ${action === "lock" ? "di convalida" : "di sblocco"} è obbligatorio`,
    lockUnlockSuccess: (action, count) => `${count} diari ${action === "lock" ? "bloccati" : "sbloccati"}`,
    errorResolvedSuccess: "Errore risolto correttamente",
    failedResolveError: (message) => `Risoluzione dell'errore non riuscita: ${message}`,
    healthCheckCompleted: (message) => `Controllo di integrità completato: ${message}`,
    healthCheckFailed: (message) => `Controllo di integrità non riuscito: ${message}`,
    expectedCountUpdatedSuccess: "Numero atteso aggiornato correttamente",
    failedUpdateExpectedCount: (message) => `Aggiornamento del numero atteso non riuscito: ${message}`,
    fixedRecords: (fixed, failed) => `${fixed} record corretti${failed ? `, ${failed} non riusciti` : ""}`,
    failedFixSharedAttributes: (message) => `Correzione degli attributi condivisi non riuscita: ${message}`,
    failedAssignRole: (message) => `Assegnazione del ruolo non riuscita: ${message}`,
    failedLoadMessages: "Caricamento dei messaggi non riuscito",
    loggedInSuccess: "Accesso riuscito",
    unknownLoginError: "Errore di accesso sconosciuto",
    userDeleted: "Utente eliminato",
    passwordSetSuccess: "Password impostata correttamente.",
    emailVerificationSent: "E-mail di verifica inviata",
    verificationCodeSent: "Codice di verifica inviato",
    verificationCodeSentEmail: "Codice di verifica inviato al Suo indirizzo e-mail",
    failedSendVerificationCode: "Invio del codice di verifica non riuscito",
    emailVerificationFailed: "Verifica dell'e-mail non riuscita",
    emailVerified: "E-mail verificata",
    emailVerifiedShort: "E-mail verificata.",
    invalidVerificationCode: "Codice di verifica non valido",
    emailSetSuccess: "Indirizzo e-mail impostato correttamente",
    emailSavedToProfileToast: "Indirizzo e-mail salvato nel Suo profilo",
    emailUpdatedSuccessToast: "Indirizzo e-mail aggiornato correttamente",
    superUserStatusUpdated: "Stato di superutente aggiornato",
    userInvited: "Utente invitato",
    profileAttributeLocked: "L'attributo del profilo è bloccato",
    addressAlreadyInUse: "Questo indirizzo è già in uso.",
    mustBeSignedIn: "Deve aver effettuato l'accesso.",
    contactPersonRequired: "La persona di contatto è obbligatoria.",
    somethingWentWrong: "Si è verificato un errore. La preghiamo di riprovare.",
    resultsSentToEmail: "Risultati inviati al Suo indirizzo e-mail.",
    resultsEmailSendFailed:
        "I Suoi risultati sono pronti, ma non è stato possibile inviare l'e-mail. La preghiamo di riprovare più tardi.",
    fixHighlightedFieldsBeforeInvite: "Corregga i campi evidenziati prima di inviare l'invito.",
    pdfDownloaded: "PDF scaricato",
    pdfDownloadFailed: "Download del PDF non riuscito",
    pdfGenerationFailed: "Generazione del PDF non riuscita",
    questionnaireResumed: "Questionario ripreso",
    errorResumingQuestionnaire: "Errore durante la ripresa del questionario",
    trackerDeletedSuccess: "Monitoraggio eliminato correttamente",
    diaryCreatedSuccess: "Diario creato correttamente",
    diaryDeletedSuccess: "Diario eliminato correttamente",
    templateSavedSuccess: "Modello salvato correttamente",
    failedSaveTemplate: "Salvataggio del modello non riuscito",
    diaryAccessRemoved: "Accesso al diario rimosso",
    failedRemoveDiaryAccess: "Rimozione dell'accesso al diario non riuscita",
    entryRemindersTriggered: "Promemoria di inserimento attivati per il monitoraggio",
    correctionSaved: "Correzione salvata",
    correctionReasonRequired: "Il motivo della correzione è obbligatorio",
    errorAddingPatient: "Errore durante l'aggiunta del paziente, aggiorni la pagina e riprovi.",
    invalidDate: "Data non valida",
    failedCreateDiary: (message) => `Creazione del diario non riuscita: ${message}`,
    failedUpdateEntry: (message) => `Aggiornamento dell'inserimento non riuscito: ${message}`,
    failedDeleteSchedule: (message) => `Eliminazione del calendario non riuscita: ${message}`,
    failedCopySchedule: (message) => `Copia del calendario non riuscita: ${message}`,
    errorAddingUserToOrganisation: (message) => `Errore durante l'aggiunta dell'utente all'organizzazione: ${message}`,
    emailRequiredRefresh:
        "Abbiamo bisogno del Suo indirizzo e-mail per continuare. Aggiorni la pagina e invii di nuovo il modulo.",
    templateStillLoading: "Il modello è ancora in caricamento. Riprovi tra un attimo.",
    phoneUpdatedSuccess: "Numero di telefono aggiornato correttamente",
    failedUpdatePhone: "Aggiornamento del numero di telefono non riuscito. La preghiamo di riprovare.",
    completeRequiredFields: (fieldsList) => `Completi i seguenti campi obbligatori:\n${fieldsList}`,
    missingEntry: "Inserimento mancante",
    formSubmissionError: (message) => `Errore durante l'invio del modulo: ${message}`,
    organisationDeleted: "Organizzazione eliminata",
    noRowsToExport: "Nessuna riga da esportare in questa pagina",
    exportedChangeEventsFromPage: (count) => `${count} eventi di modifica di questa pagina esportati`,
    noChangeEventsMatchFilters: "Nessun evento di modifica corrisponde a questi filtri",
    exportedChangeEvents: (count) => `${count} eventi di modifica esportati`,
    mustSignInToExportSnapshot: "Deve aver effettuato l'accesso per esportare un'istantanea",
    noDiariesToExport: "Nessun diario da esportare - modifichi prima la ricerca o i filtri",
    chooseSnapshotDateTime: "Scelga una data e un'ora di riferimento per l'istantanea",
    snapshotExported: (count, dateTime) =>
        count === 1
            ? `Istantanea esportata per 1 diario alla data del ${dateTime} UTC`
            : `Istantanea esportata per ${count} diari alla data del ${dateTime} UTC`,
    snapshotExportFailed: "Esportazione dell'istantanea non riuscita",
    exportFailed: "Esportazione non riuscita",
    exportedChangeEventsTruncated: (exported, total) =>
        `Esportazione dei primi ${exported} eventi di modifica su ${total} corrispondenti (limite di 10.000 righe)`,
    printing: "Stampa",
    failedGeneratePrintUrl: "Generazione dell'URL di stampa non riuscita",
    reportPrintQueued:
        "Rapporto messo in coda. Sarà generato sul server a breve - riprovi a stampare tra qualche minuto.",
    reportPrintRendering: "Generazione del Suo rapporto...",
    reportPrintRefreshing: "Diario aggiornato - generazione di un nuovo rapporto...",
    reportPrintPreparing: "Preparazione del Suo rapporto...",
    reportPrintTimeout:
        "La generazione del rapporto richiede più tempo del previsto. Riprovi a stampare tra qualche minuto.",
    unknownError: "Errore sconosciuto",
    failedCreateOrganisation: "Creazione dell'organizzazione non riuscita",
    correctionFailed: "Correzione non riuscita",
    couldNotSaveProcedureDate: "Impossibile salvare la data del Suo intervento",
    couldNotSave: "Impossibile salvare",
    invalidFieldSelection: "Uno o più campi hanno una selezione non valida - verifichi il modulo e riprovi.",
    completeAllRequiredFieldsBeforeSaving: "Completi tutti i campi obbligatori prima di salvare.",
    detailsAlreadySaved: "Queste informazioni sono già state salvate.",
    unableToSaveInjectionDetails:
        "Impossibile salvare le informazioni sull'iniezione. Verifichi i Suoi inserimenti e riprovi.",
    unableToSaveShockwaveDetails:
        "Impossibile salvare le informazioni sulle onde d'urto. Verifichi i Suoi inserimenti e riprovi.",
    invitationLinkExpired:
        "Questo link di invito è scaduto. Inserisca il Suo indirizzo e-mail per ottenere un nuovo codice.",
    invitationLinkInvalid:
        "Questo link non è valido oppure è scaduto. Inserisca il Suo indirizzo e-mail per ottenere un nuovo codice.",
    confirmAccountCouldNotTextTryEmail:
        "Non è stato possibile inviare un SMS a questo numero. Provi con l'indirizzo e-mail del Suo invito, se ne ha uno.",
    confirmAccountNoAccountForDetails:
        "Non abbiamo trovato alcun account corrispondente a questi dati. Verifichi oppure si rivolga al team che Le ha inviato l'invito se ha bisogno di assistenza.",
    smsVerificationUnavailableForNumber:
        "La verifica via SMS non è ancora disponibile per questo numero. Usi l'indirizzo e-mail del Suo invito, oppure si rivolga al team che Le ha inviato l'invito.",
    smsVerificationTextFailedSignup:
        "Non è stato possibile inviare un SMS di verifica a questo numero. Se ha un account, provi ad accedere con il Suo indirizzo e-mail, oppure chieda assistenza al team che Le ha inviato l'invito.",
    smsSignInNotEnabledForProject:
        "L'accesso via SMS non è attivato per questo progetto. Il team che Le ha inviato l'invito o l'assistenza possono aiutarla.",
    smsCouldNotSendCheckNumber:
        "Non è stato possibile inviare un SMS a questo numero. Verifichi il numero, provi l'accesso via e-mail, oppure si rivolga al team che Le ha inviato l'invito.",
    smsLoginTextFailedOtpDisabled:
        "Abbiamo trovato il Suo account, ma non è stato possibile inviare un SMS di accesso. Acceda con la Sua e-mail e la Sua password, oppure si rivolga al team che Le ha inviato l'invito se ha bisogno di assistenza.",
    smsLoginTextFailedAccountFound:
        "Abbiamo trovato il Suo account, ma non è stato possibile inviare un SMS di accesso a questo numero. Acceda con la Sua e-mail, oppure si rivolga al team che Le ha inviato l'invito se ha bisogno di assistenza per gli SMS.",
    clinicianUpdateFailedDescription: "Aggiornamento del clinico non riuscito. La preghiamo di riprovare.",
    lockUnlockPartialFailure: (action, succeeded, failed, failedNames, firstError) =>
        `${succeeded} ${action === "lock" ? "bloccati" : "sbloccati"}, ${failed} non riusciti: ${failedNames} (${firstError})`,
    rolesAssignedToUsers: (role, assigned, failed) =>
        `Ruolo ${role} assegnato a ${assigned} utenti${failed ? `, ${failed} non riusciti` : ""}`,
    pdfDownloadFailedDescription: "Download del PDF generato non riuscito",
    pdfGenerationFailedDescription: "Generazione del PDF non riuscita",
    pdfDownloadSuccessDescription: "Il Suo PDF è stato scaricato correttamente.",
};
